"use client";

import { cn } from "@repo/design-system/utils/cn";
import { breakTitlesAtSlash } from "@repo/design-system/utils/helpers";
import type { JSX } from "react";
import { useMediaQuery } from "usehooks-ts";

// This only adds hyphens-auto to long words on mobile
// Needs to be a function component to use useMediaQuery
export function FormattedTitle({ input }: { input: string }) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const words = breakTitlesAtSlash(input).split(" ");
  const formattedWords = words.map((word) => {
    if (word.length > 18) {
      return (
        <span className={cn(isMobile && "hyphens-auto")} key={word}>
          {word}
        </span>
      );
    }
    return word;
  });

  const result: (string | JSX.Element)[] = [];
  formattedWords.forEach((word, i) => {
    if (i !== 0) {
      result.push(" ");
    }
    result.push(word);
  });

  return <>{result}</>;
}
